/* eslint-disable no-nested-ternary */
import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import { Popover, Spin } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import Helpers from '@Apis/helpers';
import './style.scss';

/**
 *
 */
function MetricWithAmountSplit({
  data, loading, MONEY, selectedTenant, hideOverDueListPopover, showOverdueList, redirectOverDue,
}) {
  return (
    <div className="metric-with-amount-split__wrapper">
      {loading && (
        <div className="widget-loader">
          <Spin />
        </div>
      )}
      <div className="metric-with-amount-split">
        <H3Text text={data?.entity?.toProperCase()} className="metric-with-amount-split__title" />
        <H3Text text={`${data?.entity_name_title ? data?.entity_name_title : 'Unpaid Bills'} ${MONEY(data?.value || '0')}`} className="metric-with-amount-split__amount" />
        <div className="metric-with-amount-split__bar">
          <Popover title={(
            <div className="metric-with-amount-split__amount-info">
              <H3Text text={MONEY(data?.currentValue || '0')} className="metric-with-amount-split__amount-value" />
              <H3Text text="Current" className="metric-with-amount-split__amount-text" />
            </div>
          )}
          >
            <div className="metric-with-amount-split__bar-current" style={{ width: `${(((data?.currentValue / data?.value) || 0) * 100)}%`, backgroundColor: data?.currentColor }} />
          </Popover>
          <Popover title={(
            <div className="metric-with-amount-split__amount-info">
              <H3Text text={MONEY(data?.overdueValue || '0')} className="metric-with-amount-split__amount-value" />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%',
                }}
              >

                <H3Text text="Overdue" className="metric-with-amount-split__amount-text" />
                {redirectOverDue && (
                  <Link
                    className="metric-with-amount-split__amount-text"
                    to={Helpers.appendSystemDefaultFilterIdInURL(`purchase/goods-receiving?page=1&limit=10&status=ISSUED&tenant=${selectedTenant}&payment_status=NOT_PAID,PARTIALLY_PAID`)}
                  >
                    View
                  </Link>
                )}
              </div>
            </div>
          )}
          >
            <div className="metric-with-amount-split__bar-overdue" style={{ width: `${(((data?.overdueValue / data?.value) || 0) * 100)}%`, backgroundColor: data?.overdueColor }} />
          </Popover>
        </div>
        <div className="metric-with-amount-split__section">
          <div className="metric-section__left">
            <div className="metric-section__left-text" style={{ color: data?.currentColor }}>CURRENT</div>
            <H3Text text={MONEY(data?.currentValue || '0')} className="metric-section__left-value" />
          </div>
          <div className="metric-section__right">
            <div className="metric-section__right-text" style={{ color: data?.overdueColor }}>OVERDUE</div>
            {!hideOverDueListPopover ? (
              <Popover
                title={(
                  <div className="metric-section__right-popover">
                    {
                      Object.keys(data?.overdueList)?.map((item) => (
                        <div
                          className="metric-section__right-popover-row"
                          key={item}
                          onClick={() => window.open(Helpers.appendSystemDefaultFilterIdInURL(`purchase/goods-receiving?page=1&limit=10&status=ISSUED&tenant=${selectedTenant}&payment_status=NOT_PAID,PARTIALLY_PAID&from_grn_due_date=${data?.overdueList?.[item]?.fromDate}&to_grn_due_date=${data?.overdueList?.[item]?.toDate}`))}
                        >
                          <H3Text text={item?.replaceAll('_', ' ')?.toProperCase()} className="metric-section__right-popover-row-name" />
                          <H3Text text={MONEY(data?.overdueList?.[item]?.amount || '0')} className="metric-section__right-popover-row-value" />
                        </div>
                      ))
                    }
                  </div>
                )}
                placement="bottom"
              >
                <div className="metric-section__right-value">
                  {MONEY(data?.overdueValue || '0')}
                  <FontAwesomeIcon icon={faPlay} />
                </div>
              </Popover>
            ) : (
              <div className="metric-section__right-value">
                {MONEY(data?.overdueValue || '0')}
              </div>
            )}
          </div>
        </div>
        {showOverdueList ? (
          <div style={{ marginTop: '5px' }} className="metric-section__expanded">
            {
              Object.keys(data?.overdueList)?.map((item) => (
                <div
                  key={item}
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                  className="metric-section__expanded-row"
                >
                  <H3Text text={item?.replaceAll('_', ' ')?.toProperCase()} className="metric-section__expanded-name" />
                  <H3Text text={MONEY(data?.overdueList?.[item]?.amount || '0')} className="metric-section__expanded-value" />
                </div>
              ))
            }
          </div>
        ) : ''}
      </div>
    </div>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
});

MetricWithAmountSplit.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MetricWithAmountSplit));
